export default {
  // 获取服务状态
  getStatus() {
    return this.http('ExerciseCheck', 'get', '/api/v1/rectify/status');
  },

  // 获取七牛上传Token
  getUploadToken(key) {
    return this.http('ExerciseCheck', 'get', `/api/v1/upload_token?key=${key}`);
  },

  // 上传拍照记录
  postPhotoRecords(params) {
    return this.http('ExerciseCheck', 'post', '/api/v1/rectify/records', params);
  },

  // 评测提交
  postEvaluation(params) {
    return this.http('ExerciseCheck', 'post', '/api/v1/rectify/evaluations', params);
  },

  // 服务激活
  postActivate(params) {
    return this.http('ExerciseCheck', 'post', '/api/v1/rectify/activate', params);
  },

  // 获取今日计划
  getPlan(params) {
    return this.http('ExerciseCheck', 'get', `/api/v1/rectify/plan?seq=${params}`);
  },

  // 美腿打卡
  postCheckIn() {
    return this.http('ExerciseCheck', 'post', '/api/v1/rectify/checkin');
  },

  // 获取打卡日历
  getCalendar() {
    return this.http('ExerciseCheck', 'get', '/api/v1/rectify/calendar');
  },

  // 获取照片记录
  getPhotoRecords() {
    return this.http('ExerciseCheck', 'get', '/api/v1/rectify/records');
  },

  // 服务结束
  getRectifyOver() {
    return this.http('ExerciseCheck', 'get', '/api/v1/rectify/history');
  }
};
